import { render, staticRenderFns } from "./VehicleCategoryForm.html?vue&type=template&id=aefd1bf4&scoped=true&"
import script from "./VehicleCategoryForm.vue?vue&type=script&lang=js&"
export * from "./VehicleCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefd1bf4",
  null
  
)

export default component.exports